import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rr" }

import { ref, onMounted } from 'vue'
import {useRouter} from "vue-router";
import dfAvatar from '@/assets/images/avatar.png';
import Button from 'primevue/button';


export default {
  __name: 'UserMenu',
  props: {
    isAuth: {
        required: true,
        type: Boolean
    }
},
  setup(__props) {

const menu = ref()
const router = useRouter();



const toggleMenu = (event) => {
    menu.value.toggle(event)
}

const menuItems = [
    { label: 'Moje konto', icon: 'pi pi-user', command: () => router.push({name: 'AccountIndex'}) },
    { separator: true },
    { label: 'Wyloguj', icon: 'pi pi-sign-out', command: () => logout() },
]

const authMenuItems = [
    {
        label: 'Zaloguj się',
        icon: '',
        command: () => router.push('/login')
    },
    {
        label: 'Zarejestruj się',
        icon: '',
        command: () => router.push('/register')
    }
]

const user = ref({});
const logout = async () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/';
}
const getUser = async () => {
    const userItem = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
    if (userItem) {
        user.value = userItem;
    }
}

onMounted(function () {
    getUser();
    console.log(__props.isAuth)
})

return (_ctx, _cache) => {
  const _component_Menu = _resolveComponent("Menu")
  const _component_Avatar = _resolveComponent("Avatar")

  return (_openBlock(), _createElementBlock("div", {
    class: "flex items-center gap-3",
    onClick: toggleMenu
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(Button), {
        label: __props.isAuth ? user.value.display_name : 'Konto',
        class: "p-button-text name"
      }, null, 8, ["label"]),
      _createVNode(_component_Menu, {
        ref_key: "menu",
        ref: menu,
        model: __props.isAuth ? menuItems : authMenuItems,
        popup: true
      }, null, 8, ["model"])
    ]),
    _createVNode(_component_Avatar, {
      image: __props.isAuth ? user.value.logo_path : _unref(dfAvatar),
      shape: "circle",
      size: "medium",
      class: "hide-mobile"
    }, null, 8, ["image"]),
    (__props.isAuth)
      ? (_openBlock(), _createBlock(_unref(Button), {
          key: 0,
          icon: "pi pi-bars",
          text: "",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('toggle-sidebar')), ["stop"])),
          class: "hamburger-btn"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}